import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  resetStaffStatus,
  updateStaffEmploymentInfo,
} from "../../../redux/slice/staff/staffSlice";
import useInputChange from "../../../utils/hooks/useInputChange";
import { isEmptyObject } from "../../../utils/validators/validators";
import Form from "../../form/Form";
import { useDispatch } from "react-redux/";
import { flashMessage } from "../../../utils/flash";
import Select from "../../form/select/Select";

const CurrentEmployment = () => {
  const { offices } = useSelector((state) => state.office.offices);
  const [hasEditStaff, setHasEditStaff] = useState();
  const [editing, setEditing] = useState(false);
  const [error, setError] = useState({});
  const [employmentInfo, setEmploymentInfo] = useState({});

  const dispatch = useDispatch();

  // fetch records from redux state
  const { employment_information, staff_information } = useSelector(
    (state) => state?.staff.staff_information
  );
  const { isUpdated, isSuccess } = useSelector((state) => state?.staff);

  const { user_permissions } = useSelector((state) => state.auth?.user);
  const [officeValueError, setOfficeValueError] = useState("");
  const [officeValue, setOfficeValue] = useState({
    value: employmentInfo[0]?.office_id,
    label: employmentInfo[0]?.office_name,
  });

  // Update Personal Info
  const handleSubmit = () => {
    if (!officeValue?.value) {
      flashMessage("error", "Office At Employment is required");
      return;
    }

    let payload = {
      ...staffInputData,
      office_id: officeValue?.value,
      office_name: officeValue?.label,
    };

    if (isEmptyObject(error)) {
      dispatch(updateStaffEmploymentInfo(payload));
    }
  };

  const handleOfficeChange = (value) => {
    if (!value) {
      setOfficeValueError("Office at employment is required");
    } else {
      setOfficeValueError("");
    }
    setOfficeValue(value);
  };

  // declare input fields variables
  const [staffInputData, setStaffInputData] = useState({
    department: "",
    designation: "",
    unit: "",
    staff_id: "",
    office_id: "",
  });

  const resetOnClose = () => {
    setStaffInputData({
      ...staffInputData,
      department: employmentInfo[1]?.department,
      designation: employmentInfo[1]?.designation,
      unit: employmentInfo[1]?.unit,
      staff_id: employmentInfo[1]?.staff_id,
      office_id: employmentInfo[1]?.office_id,
    });
  };

  // Custom hook for input change
  const [input, handleChange] = useInputChange(
    staffInputData,
    setStaffInputData,
    error,
    setError
  );

  useEffect(() => {
    setEmploymentInfo(employment_information);
    if (employment_information) {
      setStaffInputData({
        ...staffInputData,
        department: employmentInfo[1]?.department,
        designation: employmentInfo[1]?.designation,
        unit: employmentInfo[1]?.unit,
        id: employmentInfo[1]?.id,
        staff_id: employmentInfo[1]?.staff_id,
        office_id: employmentInfo[1]?.office_id,
      });

      setOfficeValue({
        value: employmentInfo[1]?.office_id,
        label: employmentInfo[1]?.office_name,
      });
    }
  }, [employment_information, staff_information, editing]);

  useEffect(() => {
    setHasEditStaff(
      user_permissions?.some((permission) => permission.name === "edit staff")
    );
  }, [user_permissions]);

  // useEffect(() => {
  //   if (isUpdated && isSuccess) {
  //     setEditing(false);
  //     dispatch(resetStaffStatus());
  //   }
  // }, [isUpdated]);

  return (
    <>
      <Form
        setError={setError}
        submitHandler={handleSubmit}
        values={staffInputData}
      >
        <div className='row shadow-lg p-2 py-3'>
          <h4 className='fw-normal text-primary '>
            Current Employment Information
          </h4>
          <div className='col-xs-6 col-sm-6 col-md-4'>
            <h5>Designation At Employment</h5>
            {!editing && <p>{employment_information[1]?.designation}</p>}
            {editing && (
              <input
                textname='designation'
                className={`form-control update-input ${
                  error.designation && "is-invalid"
                }`}
                type='text'
                name='designation'
                value={input.designation}
                onChange={handleChange}
                id='designation'
                placeholder='designation at employment'
              />
            )}
            {error.designation && (
              <span className='invalid-feedback'>{error.designation}</span>
            )}
          </div>
          <div className='col-xs-6 col-sm-6 col-md-4'>
            <h5>Department At Employment</h5>
            {!editing && <p>{employment_information[1]?.department}</p>}
            {editing && (
              <input
                textname='department'
                className={`form-control update-input ${
                  error.department && "is-invalid"
                }`}
                type='text'
                name='department'
                value={input.department}
                onChange={handleChange}
                id='department'
                placeholder='department at employment'
              />
            )}
            {error.department && (
              <span className='invalid-feedback'>{error.department}</span>
            )}
          </div>
          <div className=' col-sm-6 col-md-4'>
            <h5>Unit At Employment</h5>
            {!editing && <p>{employment_information[1]?.unit}</p>}
            {editing && (
              <input
                textname='unit'
                className={`form-control update-input ${
                  error.unit && "is-invalid"
                }`}
                type='text'
                name='unit'
                value={input.unit}
                onChange={handleChange}
                id='unit'
                validate='false'
                placeholder='unit at employment'
              />
            )}
            {error.unit && (
              <span className='invalid-feedback'>{error.unit}</span>
            )}
          </div>
          <div className=' col-sm-6 col-md-4 mt-2'>
            <h5>Office</h5>
            {!editing && (
              <p className='text-capitalize'>
                {employment_information[0]?.office_name}
              </p>
            )}
            {editing && (
              <>
                <Select
                  onBlur={() => {
                    if (!officeValue?.value) {
                      setOfficeValueError("Office at employment is required");
                    } else {
                      setOfficeValueError("");
                    }
                  }}
                  name='office_id'
                  data={offices?.map((office) => ({
                    value: office.id,
                    label: office.office_name,
                  }))}
                  value={parseInt(officeValue?.value)}
                  onChange={(selectedOption) =>
                    handleOfficeChange(selectedOption)
                  }
                />
                {officeValueError && (
                  <p className='mb-0 text-danger'>{officeValueError}</p>
                )}
              </>
            )}
          </div>
          <div className=' col-sm-6 col-md-4 mt-2'>
            <h5>Staff ID</h5>
            {!editing && <p>{employment_information[0]?.staff_id}</p>}
            {editing && (
              <input
                textname='unit'
                className={`form-control form-control-sm update-input `}
                type='text'
                name='staff_id'
                validate='false'
                disabled
                value={input.staff_id}
                onChange={handleChange}
                id='staff_id'
                placeholder='Staff ID'
              />
            )}
          </div>
        </div>
        {hasEditStaff && (
          <div className='d-flex float-end '>
            <div>
              <button
                type='button'
                className={`btn btn-${
                  editing ? "warning" : "info"
                } btn-sm mt-3 px-4 text-white`}
                onClick={() => {
                  setEditing(editing ? false : true);
                  resetOnClose();
                }}
              >
                {editing ? "Close" : "Edit"}
              </button>
              {editing && (
                <button className='btn btn-success ms-2 btn-sm mt-3 px-4'>
                  Save
                </button>
              )}
            </div>
          </div>
        )}
      </Form>
    </>
  );
};

export default CurrentEmployment;
